// Generated by tools/catalog-import (`pnpm catalog:import --pin`). Do not edit by hand.
/**
 * The catalogue version this build is pinned to (docs/design/01 §6: every match records it). Card
 * ruleset entries are authored against its text hashes.
 */
export const CATALOG_VERSION = '20261008.1';

/**
 * Loads the pinned snapshot's raw data. A dynamic import, so bundlers emit the 2 MB snapshot as its own
 * chunk and the client only downloads it when it needs it.
 */
export async function loadPinnedCatalogData(): Promise<unknown> {
  const mod = (await import('../data/20261008.1/catalog.json')) as { default: unknown };
  return mod.default;
}
